import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Coluna } from '../../models/mat-table-model';
import { TransformService } from '../../services/transform.service';
import { SHARED_DIRECTIVES } from '../../utils/shared-directives';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'idba-mat-table-footer',
  standalone: true,
  imports: [CommonModule, SHARED_DIRECTIVES],
  templateUrl: './idba-mat-table-footer.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./idba-mat-table-footer.scss']
})
export class IdbaMatTableFooterComponent implements OnInit{
  @Input() public column: Coluna;

  constructor(public transformService: TransformService){}

  ngOnInit(): void {

  }

}
